
import { defineComponent } from "vue";

export default defineComponent({
  name: "StatTile",
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    currencySymbol: { type: String, default: "€" },
    trend: { type: String, default: "" },
    trendUp: { type: Boolean, default: true },
    variant: { type: String, default: "blue" },
    decimals: { type: Number, default: 2 },
    icon: { type: String, default: "media/icons/duotone/Navigation/Down-2.svg" }
  },
  computed: {
    formattedValue(): string {
      const value = Number(this.value) || 0;
      return value.toLocaleString(undefined, {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      });
    }
  }
});
